module.exports = __webpack_public_path__ + "static/media/Roboto-Bold.8c9110ec.ttf";